import * as React from 'react';
import { useState, useCallback, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { PopoverService } from '../../services/PopoverService';
import { getResourceString } from '../../kentico/resource-strings';

export interface LabelAndPopoverProps {
  explanation : string;
  hasPopover : boolean;
  label : string;
  fieldId : string;
  className? : string;
  containerClassName?: string;
  isLoading? : boolean;
}


export const LabelAndPopover = function(props : LabelAndPopoverProps) {

  const [showPopoverText, setShowPopoverText] = useState(false);


  const closePopoverCallback = useCallback(
    (popoverFieldId) => {
      setShowPopoverText(false);
    },
    []
  );
  
  useEffect(() => {
    PopoverService.registerPopover(props.fieldId, closePopoverCallback);
    return () => {
      PopoverService.unRegisterPopover(props.fieldId);
    };
  });

  const onClickPopoverIcon = (event) => {
    event.preventDefault();
    event.stopPropagation();
    PopoverService.closeAllPopovers(props.fieldId);
    setShowPopoverText(!showPopoverText);
    return false;
  };
  
  const labelText = ReactHtmlParser(props.label || "");
  const titleHintText = ReactHtmlParser((props.label || "").replace("&nbsp;", " "));
  const explanation = props.explanation ? ReactHtmlParser(props.explanation.replace("&nbsp;", "")) : "";
  const hasExplanationText = props.explanation && props.explanation.replace("&nbsp;", "") !== "";

  let labelClassName = "";
  if (!props.hasPopover || !props.explanation || props.explanation == "") {
    labelClassName = "label__without-popover";
  }
  return <div className={"label-and-popover " + (props.containerClassName !== undefined ? props.containerClassName : "") }>
    {props.label != "" && <label 
      className={labelClassName + " " + (props.className || "")} 
      htmlFor={props.fieldId} 
      id={props.fieldId + "-label"} 
        title={titleHintText}>{labelText}</label>}{!!props.hasPopover && 
          hasExplanationText && <a href="#" onClick={onClickPopoverIcon}
            title={getResourceString("Form.Label.ClickForPopover")}
            className="form-control__popover-icon icon icon-information">
            {!!props.hasPopover && hasExplanationText && showPopoverText && 
          <span className="form-control__popover">{explanation}</span>}
          </a>}
      {!!props.isLoading && <div className="spin-animation spinning-icon"></div>}
    </div>;
};
